var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-gray-400 text-xs mb-2"},[_vm._v(" This Test page does not work on production. ")]),_c('card',[_c('card-tab',{attrs:{"id":"select","title":"Select Element"}},[_c('test-page-select-element')],1),_c('card-tab',{attrs:{"id":"datepicker","title":"Datepicker Element"}},[_c('test-page-date-picker-element')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }